module.exports = __webpack_public_path__ + "img/ryzer-mindset.be12c49a.png";